// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2d8e5c89","703":"e5e2b169"}[chunkId] + ".chunk.js";
};